var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-linkedin",
    "data-name": "Icon awesome-linkedin",
    d: "M18.571,2.25H1.424A1.435,1.435,0,0,0,0,3.692V20.808A1.435,1.435,0,0,0,1.424,22.25H18.571A1.439,1.439,0,0,0,20,20.808V3.692A1.439,1.439,0,0,0,18.571,2.25ZM6.045,19.393H3.08V9.848H6.049v9.545ZM4.563,8.545A1.719,1.719,0,1,1,6.281,6.826,1.719,1.719,0,0,1,4.563,8.545ZM17.156,19.393H14.192V14.75c0-1.107-.022-2.531-1.54-2.531-1.545,0-1.781,1.205-1.781,2.451v4.723H7.906V9.848H10.75v1.3h.04A3.122,3.122,0,0,1,13.6,9.612c3,0,3.558,1.978,3.558,4.549Z",
    transform: "translate(0 -2.25)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLn);
export default __webpack_public_path__ + "static/media/ln.872b86d159cafcbd1874597a19bb8036.svg";
export { ForwardRef as ReactComponent };